import React from 'react';
import classnames from 'classnames';
import { InfoTooltip } from '../info-tooltip/info-tooltip';

interface Props {
    id: string;
    isMobile: boolean;
    className?: string;
    style?: React.CSSProperties;
    children: string;
}

export const OverflowTooltip = ({ id, className, style, children, isMobile }: Props) => {
    return (
        <InfoTooltip
            id={id}
            isMobile={isMobile}
            content={children}
            className={classnames('overflow-tooltip', className)}
            style={style}
            variant='overflow'
            shouldShow={el => el.scrollWidth > el.clientWidth}
        >
            {children}
        </InfoTooltip>
    );
};
